import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArSymf8UjB5-UnYlws3ou0FRF5iEjxJD4",
  authDomain: "guestxp.firebaseapp.com",
  projectId: "guestxp",
  storageBucket: "guestxp.appspot.com",
  messagingSenderId: "615569120384",
  appId: "1:615569120384:web:5a1a001ffc3a5579819a65",
};
export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
